<template>
  <div v-if="becomeAnIBModalActive" class="fixed flex justify-center items-center inset-0 z-50 bg-gray-900 bg-opacity-70 w-full h-full overflow-y-auto">
    <div id="partnersModal" :class="zoomScale === 1.5 ? 'mt-16' : 'm-auto'" class="bg-white rounded-lg w-11/12 lg:w-[642px] max-w-[642px] maxMd:mt-20 m-auto relative">
      <button @click="closeModal" class="bg-white rounded-full h-10 w-10 absolute -top-14 ltr:right-0 rtl:left-0 appearance-none p-0">
        <div class="h-6 w-0.5 bg-blue rotate-45 ltr:ml-5 rtl:mr-5"></div>
        <div class="h-6 w-0.5 bg-blue -rotate-45 -mt-6 ltr:ml-5 rtl:mr-5"></div>
      </button>
      <ValidationObserver ref="observer" v-slot="{ invalid }">
        <div id="innerPartnersDiv" :class="zoomScale === 1.5 ? 'py-8' : 'py-10'" class="maxMd:px-5 px-12 overflow-y-auto">
          <div class="flex items-center gap-8 mb-4">
            <img src="../assets/img/partners-icon.svg" class="h-12 w-12" />
            <p :class="zoomScale === 1.5 ? 'text-[2rem]' : 'text-[2.5rem]'" class="font-display font-bold text-gray-900">
              {{ $t('become_a_partner').tTitle() }}
            </p>
          </div>

          <div>
            <label class="text-gray-900 text-base font-normal pb-2" for="ib_main_target_region">{{ $t('what_geographic_region') }}</label>
            <ValidationProvider :name="$t('what_geographic_region')" rules="required|max:255" v-slot="{ errors }">
              <input
                class="rounded-md bg-gray-100 min-h-10 ltr:pl-5 rtl:pr-5 w-full mt-2 text-base text-gray-900 font-semibold focus:outline-none focus:ring-0 border border-gray-100 border-solid focus:border-gray-900 placeholder:text-gray-900 placeholder:text-opacity-20"
                :class="{ 'ring-1 ring-orange bg-blue-200': errors.length }"
                v-model="ibMainTargetRegion"
              />
              <span v-if="errors.length" class="font-body text-xs text-orange font-semibold">{{ errors[0] }}</span>
            </ValidationProvider>
          </div>

          <div class="mt-5">
            <label class="text-gray-900 text-base font-normal pb-2" for="socialMediaInput">{{ $t('website_social_media') }}</label>
            <input
              class="rounded-md bg-gray-100 ltr:pl-5 rtl:pr-5 w-full min-h-10 mt-2 text-base text-gray-900 font-semibold focus:outline-none focus:ring-0 border border-gray-100 border-solid focus:border-gray-900 placeholder:text-gray-900 placeholder:text-opacity-20"
              v-model="ibWebsiteSocialMedia"
            />
          </div>

          <div class="mt-5">
            <ValidationProvider :name="$t('partners_agreement')" rules="required|is-true" v-slot="{ errors }">
              <div class="form-check relative flex items-center">
                <input class="checkbox" :class="{ 'ring-1 ring-orange bg-blue-200': errors.length }" type="checkbox" v-model="ibPartnersAgreement" />
                <label class="checkbox-label" for="acceptBonus">
                  {{ $t('accept') }}
                  <a :href="partnersAgreement" target="_blank" class="underline">{{ $t('partners_agreement') }}</a>
                </label>
              </div>
              <span v-if="errors.length" class="font-body text-xs text-orange font-semibold">{{ errors[0] }}</span>
            </ValidationProvider>
          </div>
          <p class="pt-2 text-xs text-gray-900 text-opacity-80 font-normal leading-[1.1rem]" v-if="User.wallet.currency !== 'USD'">
            {{ $t('note_wallet_currency_conversion_partner') }}
          </p>
          <div class="mt-4 flex gap-5">
            <button class="py-2.5 w-48 bg-blue rounded-md text-white font-semibold text-center cursor-pointer text-base" :disabled="invalid" @click.prevent="submitForm">
              {{ $t('become_a_partner').tTitle() }}
            </button>
          </div>
        </div>
      </ValidationObserver>
    </div>
  </div>
</template>

<script>
import { ValidationObserver, ValidationProvider, Validator } from 'vee-validate'
import links from '@/config/links'
import { mapGetters } from 'vuex'

// Register the custom "is-true" rule
Validator.extend('is-true', {
  validate: value => value === true,
  // getMessage: field => `${field} ////// must be accepted.`
})

export default {
  props: {
    becomeAnIBModalActive: {
      type: Boolean,
      required: true,
    },
    zoomScale: {
      type: Number,
      default: 1,
    },
  },
  components: {
    ValidationObserver,
    ValidationProvider,
  },
  data() {
    return {
      ibMainTargetRegion: '',
      ibWebsiteSocialMedia: '',
      ibPartnersAgreement: false,
    }
  },
  computed: {
    ...mapGetters({
      Language: 'language/code',
      User: 'user/all',
      UserInfo: 'user/info',
    }),
    partnersAgreement() {
      return links.getLink('partnersAgreement', 'en')
    },
  },
  methods: {
    closeModal() {
      this.$emit('close-modal')
    },
    async submitForm() {
      const isValid = await this.$refs.observer.validate()
      if (isValid) {
        this.updateToAnIB()
      }
    },
    updateToAnIB() {
      this.$emit('update-ib', {
        ibMainTargetRegion: this.ibMainTargetRegion,
        ibWebsiteSocialMedia: this.ibWebsiteSocialMedia,
        ibPartnersAgreement: this.ibPartnersAgreement,
      })
    },
  },
}
</script>
